export const CANCELLED_MATCH_STATUS = "CANCELLED";
export const PENDING_MATCH_STATUS = "PENDING";

export const isCancelledMatch = (match) =>
  String(match?.status || "").toUpperCase() === CANCELLED_MATCH_STATUS;

export const isPendingMatch = (match) =>
  String(match?.status || "").toUpperCase() === PENDING_MATCH_STATUS;
